<div class="dialog-content-max" *ngIf="!isOnlyView && !isemail" >
  <form [formGroup]="OrganisationForm" *ngIf="loginuserid==0">
    <div class="formgrid grid">
      <div class="field col-6">
        <label for="orgname" class="required-label">Organisation Name<span class="maxchars">(Max 100 chars)</span><span>*</span></label>
        <input 
          type="text" 
          class="form-control" 
          id="orgname" 
          placeholder="Enter Organisation Name" 
          name="orgname" 
          formControlName="orgname" 
          >
          <span style="color:red" *ngIf="OrganisationForm.get('orgname').invalid && (OrganisationForm.get('orgname').touched || OrganisationForm.get('orgname').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'orgname')}}
          </span>
      </div>
         <div class="field col-6">
        <label for="address">Address <span class="maxchars">(Max 500 chars)</span>
          <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
        </label>
         <textarea type="text" #remarksTA class="form-control maxhight"
          id="address" 
          placeholder="Enter Address" 
          name="address"formControlName="address"  
         [autoResize]="true" pInputTextarea >   </textarea>   
        <!-- <input 
          type="text" 
          class="form-control" 
          id="address" 
          placeholder="Enter Address" 
          name="address" 
          formControlName="address" 
          > -->
          <span style="color:red" *ngIf="OrganisationForm.get('address').invalid &&( OrganisationForm.get('address').touched ||  OrganisationForm.get('address').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'address')}}
          </span>
      </div>
    </div>
   <div class="formgrid grid">
      <div class="field col-6">
        <label for="city" class="required-label">City <span class="maxchars">(Max 100 chars)</span>
          <span>*</span>
        </label>
        <input type="text" class="form-control" id="city"   placeholder="Enter City"   name="city" formControlName="city" >
          <span style="color:red" *ngIf="OrganisationForm.get('city').invalid && (OrganisationForm.get('city').touched || OrganisationForm.get('city').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'city')}}
          </span>
      </div>
        <div class="field col-6">
        <label for="addressstate" class="required-label">Address State<span style="color: rgb(222, 30, 30); font-weight: bold;">*</span></label>
            <p-dropdown [filter]="true" [resetFilterOnHide]="true"  [showClear]="true" pTooltip="Select Address state" [options]="statelist"
                placeholder="Select Address state" optionLabel="statename" optionValue="statename" styleClass="fixed-width-dropdown-filter" 
                name="addressstate" id="addressstate" appendTo="body" formControlName="addressstate"  ></p-dropdown>
          <span style="color:red" *ngIf="OrganisationForm.get('addressstate').invalid && OrganisationForm.get('addressstate').touched ">
            {{getErrorMessage(OrganisationForm,validation_message,'addressstate')}}
          </span>
      </div>
   </div>
     <div class="formgrid grid">
      <div class="field col-6">
        <label for="country">Country
          <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
        </label>
        <!-- <input type="text" class="form-control" id="country"   placeholder="Enter country"
           name="country" formControlName="country"   required> -->
           <p-dropdown [filter]="true" [resetFilterOnHide]="true"   [showClear]="true" pTooltip="Select Country" [options]="contrylist"
                placeholder="Select Country" optionLabel="countryname" optionValue="countryname" styleClass="fixed-width-dropdown-filter" 
                name="country" appendTo="body" formControlName="country"  ></p-dropdown>
          <span style="color:red" *ngIf="OrganisationForm.get('country').invalid && OrganisationForm.get('country').touched ">
            {{getErrorMessage(OrganisationForm,validation_message,'country')}}
          </span>
      </div>
        <div class="field col-6">
        <label for="pin">Pin <span class="maxchars">(Max 100 chars)</span><span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>   </label>
        <input type="text"  class="form-control"  id="pin"  placeholder="Enter Pin"  name="pin"  formControlName="pin">
          <span style="color:red" *ngIf="OrganisationForm.get('pin').invalid && (OrganisationForm.get('pin').touched || OrganisationForm.get('pin').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'pin')}}
          </span>
      </div>
   </div>
     <div class="formgrid grid">
        <div class="field col-4">
          <label for="phone">Phone <span class="maxchars">(Max 15 chars)</span></label>
          <div class="modern-phone-wrapper">
  <div class="country-select">
    <select formControlName="countryCode">
      <option *ngFor="let code of contrycodes.countryCodes" [value]="code.value">
        {{ code.label }}
      </option>
    </select>
  </div>
  <input  id="phone" inputId="phone"
  class="form-control"  type="text" formControlName="phone" 
    placeholder="Enter Phone number"/>
</div>
  <span style="color:red" *ngIf="OrganisationForm.get('phone').invalid && (OrganisationForm.get('phone').touched || OrganisationForm.get('phone').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'phone')}}
          </span>
      </div>
      <div class="field col-4">
         <label for="orginitial">Org Initials <span class="maxchars">(Max 30 chars)</span><span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>   </label>
        <input type="text"  class="form-control"  id="orginitial"  placeholder="Enter Org Initials"  name="orginitial"  formControlName="orginitial">
          <span style="color:red" *ngIf="OrganisationForm.get('orginitial').invalid && (OrganisationForm.get('orginitial').touched || OrganisationForm.get('orginitial').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'orginitial')}}
          </span>
      </div>
        <div class="field col-4">
        <label for="orgtype">Organisation Type
          <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
        </label>
              <p-dropdown  [showClear]="true" pTooltip="Select Organisation type" [options]="orgtylist"
                placeholder="Select Organisation type" optionLabel="label" optionValue="value" styleClass="fixed-width-dropdown-filter" 
                name="orgtype" id="orgtype" appendTo="body" formControlName="orgtype"  ></p-dropdown>
          <span style="color:red" *ngIf="OrganisationForm.get('orgtype').invalid && OrganisationForm.get('orgtype').touched ">
            {{getErrorMessage(OrganisationForm,validation_message,'orgtype')}}
          </span>
      </div>
      
   </div>
    
    
     <div class="formgrid grid">
      <div class="field col-6">
        <label for="noofcompany">No. of Entity <span class="maxchars">(Max 6 Digits)</span>
          <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
        </label>
        <input type="text" class="form-control" id="noofcompany"   placeholder="Enter No of entity"   name="noofcompany" formControlName="noofcompany" (keypress)="utilityservice.onlyNumberKeywithoutlen($event)"  >
          <span style="color:red" *ngIf="OrganisationForm.get('noofcompany').invalid && (OrganisationForm.get('noofcompany').touched || OrganisationForm.get('noofcompany').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'noofcompany')}}
          </span>
      </div>
        <div class="field col-6">
        <label for="noofuser">No. of User <span class="maxchars">(Max 5 Digits)</span><span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>   </label>
        <input type="text"  class="form-control"  id="noofuser"  placeholder="Enter No of user"  name="noofuser"  formControlName="noofuser"  (keypress)="utilityservice.onlyNumberKeywithoutlen($event)" >
          <span style="color:red" *ngIf="OrganisationForm.get('noofuser').invalid && (OrganisationForm.get('noofuser').touched || OrganisationForm.get('noofuser').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'noofuser')}}
          </span>
      </div>

   </div>
     <div class="formgrid grid">
      <div class="field col-6">
        <label for="nooflocation">No. Of Location <span class="maxchars">(Max 5 Digits)</span>
          <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
        </label>
        <input type="text" class="form-control" id="nooflocation"   placeholder="Enter No of location"   name="nooflocation" formControlName="nooflocation" (keypress)="utilityservice.onlyNumberKeywithoutlen($event)" >
          <span style="color:red" *ngIf="OrganisationForm.get('nooflocation').invalid && (OrganisationForm.get('nooflocation').touched || OrganisationForm.get('nooflocation').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'nooflocation')}}
          </span>
      </div>
        <div class="field col-6">
        <label for="spaceallowed">Space Allowed(in GB) <span class="maxchars">(Max 5 digits)</span><span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>   </label>
        <input type="text"  class="form-control"  id="spaceallowed"  placeholder="Enter Space allowed"  name="spaceallowed"  formControlName="spaceallowed" (keypress)="utilityservice.onlyNumberKeywithoutlen($event)" >
          <span style="color:red" *ngIf="OrganisationForm.get('spaceallowed').invalid && (OrganisationForm.get('spaceallowed').touched || OrganisationForm.get('spaceallowed').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'spaceallowed')}}
          </span>
      </div>
   </div>
     <div class="formgrid grid">
      <div class="field col-6">
        <label for="nooftraining">No. of Training <span class="maxchars">(Max 5 Digits)</span>
          <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
        </label>
        <input type="text" class="form-control" id="nooftraining"   placeholder="Enter no of Training"   name="nooftraining" formControlName="nooftraining" (keypress)="utilityservice.onlyNumberKeywithoutlen($event)"  >
          <span style="color:red" *ngIf="OrganisationForm.get('nooftraining').invalid &&( OrganisationForm.get('nooftraining').touched || OrganisationForm.get('nooftraining').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'nooftraining')}}
          </span>
      </div>
        <div class="field col-6">
        <label for="esign">Enable Esign ?</label>
           <p-dropdown  [showClear]="true" pTooltip="Select Org type" [options]="yesnolist"
                placeholder="Select" optionLabel="label" optionValue="value" styleClass="fixed-width-dropdown-filter" 
                name="country" appendTo="body" formControlName="esign"  ></p-dropdown>
         
      </div>
   </div>
     <div class="formgrid grid">
      <div class="field col-6">
        <label for="product">Product Modules
          <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
        </label>
         <p-multiSelect [filter]="true"[resetFilterOnHide]="true"   [showClear]="true" [options]="productlist"
                placeholder="Select Modules Products" optionLabel="productname" inputId="productid" styleClass="fixed-width-dropdown-filter" 
                name="product" id="product" appendTo="body" formControlName="product"  [pTooltip]="getProductTooltip(OrganisationForm.get('product').value)"  ></p-multiSelect>
          <span style="color:red" *ngIf="OrganisationForm.get('product').invalid && OrganisationForm.get('product').touched ">
            {{getErrorMessage(OrganisationForm,validation_message,'product')}}
          </span>
      </div>
        <div class="field col-6">
        <label for="dataservice">Data service<span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>   </label>
           <p-dropdown  [showClear]="true" pTooltip="Select Org type" [options]="yesnolist"
                placeholder="Select" optionLabel="label" optionValue="value" styleClass="fixed-width-dropdown-filter" 
                name="country" appendTo="body" formControlName="dataservice" [filter]="true"[resetFilterOnHide]="true"  ></p-dropdown>
          <span style="color:red" *ngIf="OrganisationForm.get('dataservice').invalid && OrganisationForm.get('dataservice').touched">
            {{getErrorMessage(OrganisationForm,validation_message,'dataservice')}}
          </span>
      </div>
   </div>
     <div class="formgrid grid">
      <div class="field col-6">
        <label for="state">States Availability<span style="color: rgb(222, 30, 30); font-weight: bold;">*</span></label>
                <p-multiSelect [options]="statelist"  name="state" id="state" inputId="stateid"
                 optionLabel="statename"  appendTo="body" placeholder="Select"
                 formControlName="state" [filter]="true"[resetFilterOnHide]="true" [pTooltip]="getStatesavailbleTooltip(OrganisationForm.get('state').value)" ></p-multiSelect>
          <span style="color:red" *ngIf="OrganisationForm.get('state').invalid && OrganisationForm.get('state').touched ">
            {{getErrorMessage(OrganisationForm,validation_message,'state')}}
          </span>
      </div>
        <div class="field col-6">
        <label for="isenterprise">Is Enterprise<span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>   </label>
               <p-dropdown  [showClear]="true" pTooltip="Select Org type" [options]="enterpriselist"
                placeholder="Select" optionLabel="label" optionValue="value" styleClass="fixed-width-dropdown-filter" 
                name="isenterprise" id="isenterprise" appendTo="body" formControlName="isenterprise"  ></p-dropdown>
          <span style="color:red" *ngIf="OrganisationForm.get('isenterprise').invalid && OrganisationForm.get('isenterprise').touched ">
            {{getErrorMessage(OrganisationForm,validation_message,'isenterprise')}}
          </span>
      </div>
   </div>
     <div class="formgrid grid">
      <div class="field col-4">
        <label for="requirebusinessuser">Is Business user required
          <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
        </label>
          <p-dropdown  [showClear]="true" pTooltip="Select Org type" [options]="yesnolist"
                placeholder="Select" optionLabel="label" optionValue="value" styleClass="fixed-width-dropdown-filter" 
                name="requirebusinessuser" id="requirebusinessuser" appendTo="body" formControlName="requirebusinessuser"  ></p-dropdown>
          <span style="color:red" *ngIf="OrganisationForm.get('requirebusinessuser').invalid && OrganisationForm.get('requirebusinessuser').touched ">
            {{getErrorMessage(OrganisationForm,validation_message,'requirebusinessuser')}}
          </span>
      </div>
           <div class="field col-4" *ngIf="OrganisationForm.get('requirebusinessuser').value=='Y'" >
        <label for="noofbuser">No. Business User <span class="maxchars">(Max 5 Digits)</span>
          <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
        </label>
          <input type="text"  class="form-control" 
                placeholder="Enter No of Business User"
                name="noofbuser" id="noofbuser" formControlName="noofbuser" (keypress)="utilityservice.onlyNumberKeywithoutlen($event)"   >
          <span style="color:red" *ngIf="OrganisationForm.get('noofbuser').invalid && (OrganisationForm.get('noofbuser').touched || OrganisationForm.get('spaceallowed').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'noofbuser')}}
          </span>
      </div>
        <div class="field col-4">
        <label for="authtype">Authentication type<span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>   </label>
            <p-dropdown  [showClear]="true" pTooltip="Select Org type" [options]="authtypelist"
                placeholder="Select" optionLabel="label" optionValue="value" styleClass="fixed-width-dropdown-filter" 
                name="authtype" id="authtype" appendTo="body" formControlName="authtype"  ></p-dropdown>
          <span style="color:red" *ngIf="OrganisationForm.get('authtype').invalid && OrganisationForm.get('authtype').touched ">
            {{getErrorMessage(OrganisationForm,validation_message,'authtype')}}
          </span>
      </div>
   </div>
   <div class="grid" *ngIf="isEdit">
  <div class="field col-4">
        <label for="databackupdownloadflag">Data Backup<span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>   </label>
            <p-dropdown  [showClear]="true" pTooltip="Select Org type" [options]="yesnolist"
                placeholder="Select" optionLabel="label" optionValue="value" styleClass="fixed-width-dropdown-filter" 
                name="databackupdownloadflag" id="databackupdownloadflag" appendTo="body" formControlName="databackupdownloadflag"  ></p-dropdown>
          <span style="color:red" *ngIf="OrganisationForm.get('databackupdownloadflag').invalid && OrganisationForm.get('databackupdownloadflag').touched ">
            {{getErrorMessage(OrganisationForm,validation_message,'databackupdownloadflag')}}
          </span>
      </div>
        <div class="field col-4">
        <label for="issuspended">Is Suspended<span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>   </label>
            <p-dropdown  [showClear]="true" pTooltip="Select Org type" [options]="yesnolist"
                placeholder="Select" optionLabel="label" optionValue="value" styleClass="fixed-width-dropdown-filter" 
                name="issuspended" id="issuspended" appendTo="body" formControlName="issuspended"  ></p-dropdown>
          <span style="color:red" *ngIf="OrganisationForm.get('issuspended').invalid && OrganisationForm.get('issuspended').touched ">
            {{getErrorMessage(OrganisationForm,validation_message,'issuspended')}}
          </span>
      </div>
        <div class="field col-3">
        <label for="dolive">Go Live Date </label>
         <p-calendar styleClass="pcalendar"  formControlName="dolive" id="dolive" name="dolive" appendTo="body" 
              [readonlyInput]="true" [showButtonBar]="true" [showOtherMonths]="false" [monthNavigator]="true" [yearNavigator]="true"
              [showIcon]="true" dateFormat="dd-M-yy"
              placeholder="Choose Date"></p-calendar> 
               

         
        
      </div>
   </div>



   <p-accordion [activeIndex]="0">
   <p-accordionTab  header="Organisation Admin Details">
         <div class="formgrid grid">
      <div class="field col-6">
        <label for="firstname">First Name<span *ngIf="!isEdit" class="maxchars">(Max 100 chars)</span>
          <span *ngIf="!isEdit" style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
        </label>
        <input type="text" class="form-control" id="firstname"   placeholder="Enter First Name"   name="firstname" formControlName="firstname" [readonly]="isEdit">
          <span style="color:red" *ngIf="OrganisationForm.get('firstname').invalid && (OrganisationForm.get('firstname').touched || OrganisationForm.get('firstname').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'firstname')}}
          </span>
      </div>
        <div class="field col-6">
        <label for="lastname">Last Name <span *ngIf="!isEdit" class="maxchars">(Max 100 chars)</span><span *ngIf="!isEdit" style="color: rgb(222, 30, 30); font-weight: bold;">*</span>   </label>
        <input type="text"  class="form-control"  id="lastname"  placeholder="Enter Last Name"  name="lastname"  formControlName="lastname" [readonly]="isEdit" >
          <span style="color:red" *ngIf="OrganisationForm.get('lastname').invalid && (OrganisationForm.get('lastname').touched || OrganisationForm.get('firstname').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'lastname')}}
          </span>
      </div>
   </div>
        <div class="formgrid grid">
      <div class="field col-6">
        <label for="email">Email Address<span *ngIf="!isEdit" class="maxchars">(Max 100 chars)</span>
          <span *ngIf="!isEdit" style="color: rgb(222, 30, 30); font-weight: bold;">*</span>
        </label>
        <input type="text" class="form-control" id="email"   placeholder="Enter Email Address"   name="email" formControlName="email"  [readonly]="isEdit">
          <span style="color:red" *ngIf="OrganisationForm.get('email').invalid && (OrganisationForm.get('email').touched || OrganisationForm.get('email').dirty) ">
            {{getErrorMessage(OrganisationForm,validation_message,'email')}}
          </span>
      </div>
        <div class="field col-6">
        <label for="file">Upload File<span style="color: rgb(222, 30, 30); font-weight: bold;">*</span>   </label>
        <span *ngIf="isEdit" class="classfile"> {{filename}} &nbsp; <i class="fa fa-download downloadicon"  (click)="download(filename)"></i></span>
       <input  type="file" id="file"class="displaydefaulttext" (change)="onFileSelected($event)"  accept=".jpg,.jpeg,.png,image/jpeg,image/png">
      </div>
   </div>
    </p-accordionTab>
    
    </p-accordion>
    <div class="grid" *ngIf="isEdit">
   <div class="col-4">
   <label for="licenseChange">Do You Want to keep licence change</label>
      <p-dropdown [filter]="true"  [showClear]="true" pTooltip="Select Address state" [options]="yesnolist"
                placeholder="Select User" optionLabel="label" optionValue="value" styleClass="fixed-width-dropdown-filter" 
                name="licenseChange" id="licenseChange" appendTo="body" formControlName="licenseChange"  ></p-dropdown>
   </div>
    </div>
       <p-accordion [activeIndex]="0">
   <p-accordionTab  header="License Related Changes">
    <div *ngIf="tableData.length>0">
   <p-table #dt [value]="tableData"[rows]="rows2" [scrollable]="true" scrollDirection="horizontal"
      [customSort]="true" (sortFunction)="this.utilityservice.customSort($event)"
       scrollHeight="{{commonScrollHeight}}" [globalFilterFields]="filedsname"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"(onPage)="handlePageChange($event)"
        [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true" [showCurrentPageReport]="true"
        paginatorLocale="fa-IR" [paginator]="true"   [sortOrder]="1" responsiveLayout="scroll">
        <ng-template pTemplate="caption">
          <div class="grid table-header">
            <div class="col-12 md:col-10 sm:col-12 lg:col-10">
              <span class=" p-input-icon-lft">
                <i icon="pi pi-search"></i>
                <input class="form-control" pInputText type="text" id="tablesearch"
                (input)="dt.filterGlobal($any($event.target).value , 'contains')" placeholder="Search in License Related Changes"
                  class="tablesearch" pTooltip="Enter Search Criteria" tooltipPosition="top" />
              </span>
            </div>
             <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
              <div class="iconexcel" pTooltip="Download Excel Data" tooltipPosition="bottom"
              (click)="downloadexcel()"></div>
            </div>
          </div>
      </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <ng-container *ngFor="let col of _selectedColumns">
              <th [pSortableColumn]="col.field" *ngIf="col.isChecked">
                {{col.header}}<p-sortIcon [field]="col.field" ></p-sortIcon>
                <p-columnFilter type="text" [field]="col.field" display="menu"></p-columnFilter>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
          <tr>
            <ng-container *ngFor="let col of _selectedColumns" >
            <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class"  >
              <span  pTooltip=" {{data[col.field] }}">{{data[col.field]}}</span> 
               <!-- <span pTooltip=" {{data[col.field] }}">{{data[col.field]}}</span>  -->

            </td>
          </ng-container>
          </tr>
        </ng-template>
           <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="_selectedColumns.length + 1"  class="datanotfound">
                No data available
            </td>
        </tr>
    </ng-template>
      </p-table>
    </div>
    
    </p-accordionTab>
    
    </p-accordion>

  </form>

</div>
<div class="dialog-content-max" *ngIf="isOnlyView && !isemail" >
  <form [formGroup]="OrganisationForm">
    <div class="formgrid grid">
      <div class="field col-6">
        <label for="orgname">Organisation Name</label>
        <input 
          type="text" 
          class="form-control" 
          id="orgname" 
          placeholder="Enter Organisation Name" 
          name="orgname" 
          formControlName="orgname" 
          readonly>
      </div>
         <div class="field col-6">
        <label for="address">Address</label>
        <input 
          type="text" 
          class="form-control" 
          id="address" 
          placeholder="Enter Address" 
          name="address" 
          formControlName="address" 
          readonly>
      </div>
    </div>
   <div class="formgrid grid">
      <div class="field col-6">
        <label for="city">City</label>
        <input type="text" class="form-control" id="city"   placeholder="Enter City"   name="city" formControlName="city"   readonly>
    
      </div>
        <div class="field col-6">
        <label for="addressstate">Address State</label>
            <input type="text" class="form-control"
                name="addressstate" id="addressstate" appendTo="body" formControlName="addressstate" readonly >

      </div>
   </div>
     <div class="formgrid grid">
      <div class="field col-6">
        <label for="country">Country</label>
        <input type="text" class="form-control" id="country"
           name="country" formControlName="country"   readonly>
           
      </div>
        <div class="field col-6">
        <label for="pin">Pin  </label>
        <input type="text"  class="form-control"  id="pin"  placeholder="Enter Pin"  name="pin"  formControlName="pin"  readonly>
       
      </div>
   </div>
     <div class="formgrid grid">
      <div class="field col-6">
        <label for="phone">Phone</label>
        <input type="text" class="form-control" name="Phone"  id="phone"  formControlName="phone" readonly>
        
      </div>
        <div class="field col-6">
        <label for="orginitial">Org Initials </label>
        <input type="text"  class="form-control"  id="orginitial"  name="orginitial"  formControlName="orginitial"  readonly>
       
      </div>
   </div>
     <!-- <div class="formgrid grid">
      <div class="field col-6">
        <label for="orgtype">Organisation Type</label>
        <input type="text" class="form-control" id="orgtype" 
           name="orgtype" formControlName="orgtype"   readonly>
             
      </div>
   </div> -->
     <!-- <div class="formgrid grid">
      <div class="field col-6">
        <label for="noofcompany">No. of Entity </label>
        <input type="text" class="form-control" id="noofcompany" name="noofcompany" formControlName="noofcompany"   readonly>
       
      </div>
        <div class="field col-6">
        <label for="noofuser">No. of User</label>
        <input type="text"  class="form-control"  id="noofuser" name="noofuser"  formControlName="noofuser"  readonly>
      </div>

   </div> -->
     <!-- <div class="formgrid grid">
      <div class="field col-6">
        <label for="nooflocation">No. Of Location</label>
        <input type="text" class="form-control" id="nooflocation" name="nooflocation" formControlName="nooflocation" readonly>
      </div>
        <div class="field col-6">
        <label for="spaceallowed">Space Allowed(in GB)</label>
        <input type="text"  class="form-control"  id="spacenotallowed"  placeholder="Enter Space allowed"  name="spaceallowed"  formControlName="spaceallowed"  readonly>
       
      </div>
   </div> -->
     <div class="formgrid grid">
      <!-- <div class="field col-6">
        <label for="nooftraining">No. of training</label>
        <input type="text" class="form-control" id="nooftraining" name="nooftraining" formControlName="nooftraining"   readonly>
       
      </div> -->
        <div class="field col-3">
        <label for="esign">Enable Esign ?</label>
                <input type="text" class="form-control" id="esign" name="esign" formControlName="esign"   readonly>          
      </div>
        <div class="field col-3">
        <label for="databackupdownloadflag">Data Backup   </label>
                 <input type="text" class="form-control" id="databackupdownloadflag" name="databackupdownloadflag" formControlName="databackupdownloadflag"   readonly>          
      </div>
        <div class="field col-3">
        <label for="issuspended">Is Suspended   </label>
                 <input type="text" class="form-control" id="issuspended" name="issuspended" formControlName="issuspended"   readonly>          
      </div>
      <div class="field col-3">
        <label for="dataservice">Data service</label>
         <input type="text" class="form-control" id="dataservice" name="dataservice" formControlName="dataservice"   readonly>          
      </div>
   </div>
     <div class="formgrid grid">
      <div class="field col-6">
        <label for="product">Subscribed Modules</label>
         <textarea type="text" #remarksTA class="form-control maxhight" id="product" name="product"
          [value]="productsview" [readonly]="true" [autoResize]="true" pInputTextarea >   </textarea>     
      </div>
        <div class="field col-6">
        <label for="state">States Availability</label>
         <textarea id="state" #stateTA name="state"   [value]="stateview" class="form-control maxhight" [readonly]="true" [autoResize]="true" pInputTextarea></textarea>
      </div>
        
   </div>

 
     <div class="formgrid grid">
      <div class="field col-3">
        <label for="requirebusinessuser">Is Business user required</label>
         <input type="text" class="form-control" id="requirebusinessuser" name="requirebusinessuser" formControlName="requirebusinessuser" readonly>          
      </div>
           <div class="field col-3"  *ngIf="OrganisationForm.get('requirebusinessuser').value=='Yes'">
        <label for="noofbuser">No. Business User
        </label>
          <input type="text"  class="form-control"  name="noofbuser" id="noofbuser" formControlName="noofbuser" readonly  >
      </div>
        <div class="field col-3">
        <label for="authtype">Authentication type</label>
                   <input type="text"  class="form-control"  name="authtype" id="authtype" formControlName="authtype" readonly  >

      </div>
        <div class="field col-3">
        <label for="isenterprise">Is Enterprices   </label>
         <input type="text" class="form-control" id="isenterprise" name="isenterprise" formControlName="isenterprise"   readonly>          
      </div>
       <div class="field col-3">
                <label for="dolive">Date of go live</label>
                <input type="text" class="form-control" formControlName="dolive" id="dolive" name="dolive" readonly>
      </div>
   </div>
   <p-table *ngIf="numberColumns.length>0" [value]="numberColumns" [rowHover]="true">
      <ng-template pTemplate="caption">
         <div class="custometableheader">
        <h3>License Related information </h3>
    </div>
        <!-- <div class="text-xl font-bold">
          License Related information 
          </div> -->
    </ng-template>
    <!-- <h1>License Related information</h1> -->
                <ng-template pTemplate="header">

                  <tr>
                    <th>Parameter</th>
                    <th>Entity</th>
                   <th>Location</th>
                    <th>User</th>
                    <th >Training</th>
                    <th>Storeg(GB)</th>
                    <th>BD Users</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-i="rowIndex">
                  <tr>
                    <td class="boldtr">{{product.boldtr}}</td>
                    <td>{{ product.company }}</td>
                    <td>{{ product.location }}</td>
                    <td>{{product.user}}</td>
                    <td class="product.class">{{product.traning}} 
                      <span *ngIf="product.boldtr=='Actual Used'"> <i class="fa fa-info-circle" (click)="trainingtable()"></i></span>
                    </td>
                    <td>{{product.storeg}}</td>
                    <td>{{product.bdusers}}</td>
                    </tr>
                </ng-template>
              </p-table>
   <p-accordion [activeIndex]="0">
   <p-accordionTab  header="Organisation Admin Details">
         <div class="formgrid grid">
      <div class="field col-6">
        <label for="firstname">First Name</label>
        <input type="text" class="form-control" id="firstname"   placeholder="Enter First Name"   name="firstname" formControlName="firstname" readonly>
         
      </div>
        <div class="field col-6">
        <label for="lastname">Last Name </label>
        <input type="text"  class="form-control"  id="lastname"  placeholder="Enter Last Name"  name="lastname"  formControlName="lastname"  readonly>
       
      </div>
   </div>
        <div class="formgrid grid">
      <div class="field col-6">
        <label for="email">Email Address</label>
        <input type="text" class="form-control" id="email"   placeholder="Enter Email Address"   name="email" formControlName="email" readonly>
      </div>
        <div class="field col-6">
        <label for="file">File</label>
                <span class="classfile"> {{filename}} &nbsp; <i class="fa fa-download downloadicon"  (click)="download(filename)"></i></span>

       <!-- <input  type="file" id="file"class="displaydefaulttext" (change)="onFileSelected($event)" multiple="true"> -->
      </div>
   </div>
   <div class="grid">
     
      <div class="col-12">
       <p class="alerttext">
        The Org Admin is the Super Admin of the Organization and can add other module wise admins also. Module admins have all rights of an Org admin except the right to create Client Groups, Entities and to remove access of any module from users, which can be done only by Org Admins.
       </p>
      </div>
   </div>


  

    </p-accordionTab>
    
    </p-accordion>

       <p-accordion [activeIndex]="0" *ngIf="loginuserid===0 || bdTeam==true">
   <p-accordionTab  header="License Related Changes">
    <div *ngIf="tableData.length>0">
   <p-table #dt [value]="tableData"[rows]="rows2" [scrollable]="true" scrollDirection="horizontal"
      [customSort]="true" (sortFunction)="this.utilityservice.customSort($event)"
       scrollHeight="{{commonScrollHeight}}" [globalFilterFields]="filedsname" [resizableColumns]="true" columnResizeMode="expand"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"(onPage)="handlePageChange($event)"
        [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true" [showCurrentPageReport]="true"
        paginatorLocale="fa-IR" [paginator]="true"   [sortOrder]="1" responsiveLayout="scroll">
        <!-- search -->
     
        <ng-template pTemplate="caption">
          <div class="grid table-header">
            <div class="col-12 md:col-10 sm:col-12 lg:col-10">
              <span class=" p-input-icon-lft">
                <i icon="pi pi-search"></i>
                <input class="form-control" pInputText type="text" id="tablesearch"
                (input)="dt.filterGlobal($any($event.target).value , 'contains')" placeholder="Search in License Related Changes"
                  class="tablesearch" pTooltip="Enter Search Criteria" tooltipPosition="top" />
              </span>
            </div>
             <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
              <div class="iconexcel" pTooltip="Download Excel Data" tooltipPosition="bottom"
              (click)="downloadexcel()"></div>
            </div>
          </div>
      </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <ng-container *ngFor="let col of _selectedColumns">
              <th [pSortableColumn]="col.field" pResizableColumn *ngIf="col.isChecked">
                 {{col.header}}<p-sortIcon [field]="col.field" ></p-sortIcon>
                <p-columnFilter type="text" [field]="col.field" display="menu"></p-columnFilter>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
          <tr>
            <ng-container *ngFor="let col of _selectedColumns" >
            <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class"  >
              <span  pTooltip=" {{data[col.field] }}">{{data[col.field]}}</span> 
               <!-- <span pTooltip=" {{data[col.field] }}">{{data[col.field]}}</span>  -->

            </td>
          </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div *ngIf="tableData.length==0">
        <p>No Data Found</p>
    </div>
    
    </p-accordionTab>
    
    </p-accordion>

  </form>

</div>
<div class="dialog-content-max" *ngIf="isemail" >
  <form [formGroup]="OrganisationmailForm">
  <div class="grid">
    <div class="col-12">
      <label for="product">Products</label>
       <p-multiSelect [filter]="true"  [showClear]="true" pTooltip="Select Products" [options]="productlist"
                placeholder="Select Modules Products" optionLabel="productname" inputId="productid" styleClass="fixed-width-dropdown-filter" 
                name="product" id="product" appendTo="body" formControlName="product"  ></p-multiSelect>
    </div>
  </div>
  </form>

</div>
<div class="custom-dialog-footer">
    <p-button *ngIf="isemail" class="m-1" label="Close" styleClass="customeclose" (click)="closemodal(OrganisationmailForm,this.ref,'Are you sure, you want to close?')" ></p-button>

  <p-button *ngIf="!isemail" class="m-1" label="Close" styleClass="customeclose" (click)="closemodal(OrganisationForm,this.ref,'Are you sure, you want to close?')" ></p-button>
  <p-button *ngIf="!isOnlyView && !isemail" class="m-1"  label="{{saveTitle}}" styleClass="customesave" (click)="save()" ></p-button>
    <p-button *ngIf="isemail" class="m-1"  label="Modify" styleClass="customesave" (click)="savemail()" ></p-button>


</div>
